// src/types/languages.ts
var SUPPORTED_LANGUAGES = {
  "pt-br": "Portugu\xEAs",
  en: "English",
  es: "Espa\xF1ol"
};
var LANGUAGES = {
  PT_BR: "pt-br",
  EN: "en",
  ES: "es"
};
var DEFAULT_LANGUAGE = LANGUAGES.PT_BR;

export {
  SUPPORTED_LANGUAGES,
  LANGUAGES,
  DEFAULT_LANGUAGE
};
//# sourceMappingURL=chunk-CAPATJ24.js.map